import React from 'react'
import './Footer.css'

export const Footer = () => {
  return (
    <div className='footer'>
        <p>0 2024 Edusity. All rights reserved.</p>
        <ul>
            <li>Terms of Services</li>
            <li>Privacy Policy</li>
        </ul>
    </div>
  )
}
